import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineComment } from "react-icons/ai";

function SubAdminSideBar() {
  const [activeTab, setActiveTab] = useState("LEAD_MANAGEMENT");

  return (
    <div className="si09">
      {/* Logo */}
      <div className="lo-ad">
        <figure style={{ width: "100%", height: "100px", padding: "10px", textAlign: "center" }}>
          <img src="./logo.jpeg" alt="admin logo" className="img-fluid" />
        </figure>
      </div>

      {/* Sidebar Menu */}
      <ul>
        <Link to="/SubAdminLeadManage">
          <li
            className={`a-ele ${activeTab === "LEAD_MANAGEMENT" ? "active-0" : ""}`}
            onClick={() => setActiveTab("LEAD_MANAGEMENT")}
          >
            <AiOutlineComment style={{ marginRight: "5px", fontSize: "30px" }} />
            LEAD MANAGEMENT
            <i className="fa fa-angle-right" aria-hidden="true" style={{ float: "right", fontSize: "20px", paddingRight: "20px" }}></i>
          </li>
        </Link>
        {/* <Link to="/SubAdminLeadManage">
          <li
            className={`a-ele ${activeTab === "LEAD_MANAGEMENT" ? "active-0" : ""}`}
            onClick={() => setActiveTab("LEAD_MANAGEMENT")}
          >
            <AiOutlineComment style={{ marginRight: "5px", fontSize: "30px" }} />
            LEAD Profile
            <i className="fa fa-angle-right" aria-hidden="true" style={{ float: "right", fontSize: "20px", paddingRight: "20px" }}></i>
          </li>
        </Link> */}
      </ul>
    </div>
  );
}

export default SubAdminSideBar;
